module.exports = __webpack_public_path__ + "img/ABS_poa.32b2fe06.jpg";